/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PartnerServiceProduktDto as OkEgisServiceModelsDtoPartnerServiceProduktDto } from '../models/OK/Egis/Service/Models/DTO/partner-service-produkt-dto';
import { PartnersPossibleDto as OkEgisServiceModelsDtoPartnersPossibleDto } from '../models/OK/Egis/Service/Models/DTO/partners-possible-dto';
import { PostnummerDto as OkEgisServiceModelsDtoPostnummerDto } from '../models/OK/Egis/Service/Models/DTO/postnummer-dto';
import { PartnerServiceProduktEnum as OkEgisServiceModelsEntitiesEnumsPartnerServiceProduktEnum } from '../models/OK/Egis/Service/Models/Entities/Enums/partner-service-produkt-enum';
import { PostnummerServicePartnerEntity as OkEgisServiceModelsEntitiesPostnummerServicePartnerEntity } from '../models/OK/Egis/Service/Models/Entities/postnummer-service-partner-entity';

@Injectable({
  providedIn: 'root',
})
export class PartnerPostnummerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getPostnumre
   */
  static readonly GetPostnumrePath = '/api/v1/PartnerPostnummer/GetPostnumre';

  /**
   * Returns a list of postnumre.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPostnumre()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPostnumre$Response(params: {
    onlyActive?: boolean;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoPostnummerDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerPostnummerService.GetPostnumrePath, 'get');
    if (params) {
      rb.query('onlyActive', params.onlyActive, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoPostnummerDto>>;
      })
    );
  }

  /**
   * Returns a list of postnumre.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPostnumre$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPostnumre(params: {
    onlyActive?: boolean;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoPostnummerDto>> {

    return this.getPostnumre$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoPostnummerDto>>) => r.body as Array<OkEgisServiceModelsDtoPostnummerDto>)
    );
  }

  /**
   * Path part for operation getPostnummer
   */
  static readonly GetPostnummerPath = '/api/v1/PartnerPostnummer/GetPostnummer';

  /**
   * Returns a single postnummer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPostnummer()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPostnummer$Response(params: {
    postnummer?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoPostnummerDto>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerPostnummerService.GetPostnummerPath, 'get');
    if (params) {
      rb.query('postnummer', params.postnummer, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoPostnummerDto>;
      })
    );
  }

  /**
   * Returns a single postnummer.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPostnummer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPostnummer(params: {
    postnummer?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoPostnummerDto> {

    return this.getPostnummer$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoPostnummerDto>) => r.body as OkEgisServiceModelsDtoPostnummerDto)
    );
  }

  /**
   * Path part for operation createPostnummer
   */
  static readonly CreatePostnummerPath = '/api/v1/PartnerPostnummer/CreatePostnummer';

  /**
   * create new postnummer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPostnummer()` instead.
   *
   * This method doesn't expect any request body.
   */
  createPostnummer$Response(params: {
    postnummer?: number;
    by?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoPostnummerDto>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerPostnummerService.CreatePostnummerPath, 'get');
    if (params) {
      rb.query('postnummer', params.postnummer, {});
      rb.query('by', params.by, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoPostnummerDto>;
      })
    );
  }

  /**
   * create new postnummer.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createPostnummer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createPostnummer(params: {
    postnummer?: number;
    by?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoPostnummerDto> {

    return this.createPostnummer$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoPostnummerDto>) => r.body as OkEgisServiceModelsDtoPostnummerDto)
    );
  }

  /**
   * Path part for operation updatePostnummer
   */
  static readonly UpdatePostnummerPath = '/api/v1/PartnerPostnummer/UpdatePostnummer';

  /**
   * update a postnummer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePostnummer()` instead.
   *
   * This method doesn't expect any request body.
   */
  updatePostnummer$Response(params: {
    postnummer?: number;
    by?: string;
    isActive?: boolean;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoPostnummerDto>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerPostnummerService.UpdatePostnummerPath, 'get');
    if (params) {
      rb.query('postnummer', params.postnummer, {});
      rb.query('by', params.by, {});
      rb.query('isActive', params.isActive, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoPostnummerDto>;
      })
    );
  }

  /**
   * update a postnummer.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updatePostnummer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updatePostnummer(params: {
    postnummer?: number;
    by?: string;
    isActive?: boolean;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoPostnummerDto> {

    return this.updatePostnummer$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoPostnummerDto>) => r.body as OkEgisServiceModelsDtoPostnummerDto)
    );
  }

  /**
   * Path part for operation deletePostnummer
   */
  static readonly DeletePostnummerPath = '/api/v1/PartnerPostnummer/DeletePostnummer';

  /**
   * delete a postnummer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePostnummer()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePostnummer$Response(params: {
    postnummer?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerPostnummerService.DeletePostnummerPath, 'get');
    if (params) {
      rb.query('postnummer', params.postnummer, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * delete a postnummer.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deletePostnummer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePostnummer(params: {
    postnummer?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<void> {

    return this.deletePostnummer$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getPartnerServiceProdukter
   */
  static readonly GetPartnerServiceProdukterPath = '/api/v1/PartnerPostnummer/GetPartnerServiceProdukter';

  /**
   * Returns a list of partnerserviceprodukter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerServiceProdukter()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerServiceProdukter$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerServiceProduktDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerPostnummerService.GetPartnerServiceProdukterPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerServiceProduktDto>>;
      })
    );
  }

  /**
   * Returns a list of partnerserviceprodukter.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPartnerServiceProdukter$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerServiceProdukter(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoPartnerServiceProduktDto>> {

    return this.getPartnerServiceProdukter$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerServiceProduktDto>>) => r.body as Array<OkEgisServiceModelsDtoPartnerServiceProduktDto>)
    );
  }

  /**
   * Path part for operation getPartnersPossible
   */
  static readonly GetPartnersPossiblePath = '/api/v1/PartnerPostnummer/GetPartnersPossible';

  /**
   * Returns a list of possible partners for aftale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnersPossible()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnersPossible$Response(params: {
    postnummer?: number;
    partnerServiceProduktEnum?: OkEgisServiceModelsEntitiesEnumsPartnerServiceProduktEnum;
    startdate?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoPartnersPossibleDto>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerPostnummerService.GetPartnersPossiblePath, 'get');
    if (params) {
      rb.query('postnummer', params.postnummer, {});
      rb.query('partnerServiceProduktEnum', params.partnerServiceProduktEnum, {});
      rb.query('startdate', params.startdate, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoPartnersPossibleDto>;
      })
    );
  }

  /**
   * Returns a list of possible partners for aftale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPartnersPossible$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnersPossible(params: {
    postnummer?: number;
    partnerServiceProduktEnum?: OkEgisServiceModelsEntitiesEnumsPartnerServiceProduktEnum;
    startdate?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoPartnersPossibleDto> {

    return this.getPartnersPossible$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoPartnersPossibleDto>) => r.body as OkEgisServiceModelsDtoPartnersPossibleDto)
    );
  }

  /**
   * Path part for operation getPostnummerServicePartnere
   */
  static readonly GetPostnummerServicePartnerePath = '/api/v1/PartnerPostnummer/GetPostnummerServicePartnere';

  /**
   * Returns a list of postnummer-service-partner.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPostnummerServicePartnere()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPostnummerServicePartnere$Response(params: {
    fromPostnummer?: number;
    toPostnummer?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsEntitiesPostnummerServicePartnerEntity>>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerPostnummerService.GetPostnummerServicePartnerePath, 'get');
    if (params) {
      rb.query('fromPostnummer', params.fromPostnummer, {});
      rb.query('toPostnummer', params.toPostnummer, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsEntitiesPostnummerServicePartnerEntity>>;
      })
    );
  }

  /**
   * Returns a list of postnummer-service-partner.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPostnummerServicePartnere$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPostnummerServicePartnere(params: {
    fromPostnummer?: number;
    toPostnummer?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsEntitiesPostnummerServicePartnerEntity>> {

    return this.getPostnummerServicePartnere$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsEntitiesPostnummerServicePartnerEntity>>) => r.body as Array<OkEgisServiceModelsEntitiesPostnummerServicePartnerEntity>)
    );
  }

  /**
   * Path part for operation addPostnummerServicePartner
   */
  static readonly AddPostnummerServicePartnerPath = '/api/v1/PartnerPostnummer/AddPostnummerServicePartner';

  /**
   * add partner to range of postnumre and service.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addPostnummerServicePartner()` instead.
   *
   * This method doesn't expect any request body.
   */
  addPostnummerServicePartner$Response(params: {
    partnerNo?: number;
    partnerServiceProduktEnum?: OkEgisServiceModelsEntitiesEnumsPartnerServiceProduktEnum;
    fromPostnummer?: number;
    toPostnummer?: number;
    allowFrieTilkald?: boolean;
    validFrom?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerPostnummerService.AddPostnummerServicePartnerPath, 'get');
    if (params) {
      rb.query('partnerNo', params.partnerNo, {});
      rb.query('partnerServiceProduktEnum', params.partnerServiceProduktEnum, {});
      rb.query('fromPostnummer', params.fromPostnummer, {});
      rb.query('toPostnummer', params.toPostnummer, {});
      rb.query('allowFrieTilkald', params.allowFrieTilkald, {});
      rb.query('validFrom', params.validFrom, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * add partner to range of postnumre and service.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addPostnummerServicePartner$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  addPostnummerServicePartner(params: {
    partnerNo?: number;
    partnerServiceProduktEnum?: OkEgisServiceModelsEntitiesEnumsPartnerServiceProduktEnum;
    fromPostnummer?: number;
    toPostnummer?: number;
    allowFrieTilkald?: boolean;
    validFrom?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<void> {

    return this.addPostnummerServicePartner$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation deletePostnummerServicePartner
   */
  static readonly DeletePostnummerServicePartnerPath = '/api/v1/PartnerPostnummer/DeletePostnummerServicePartner';

  /**
   * delete partner from range of postnumre and service.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePostnummerServicePartner()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePostnummerServicePartner$Response(params: {
    partnerNo?: number;
    partnerServiceProduktEnum?: OkEgisServiceModelsEntitiesEnumsPartnerServiceProduktEnum;
    fromPostnummer?: number;
    toPostnummer?: number;
    validTo?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerPostnummerService.DeletePostnummerServicePartnerPath, 'get');
    if (params) {
      rb.query('partnerNo', params.partnerNo, {});
      rb.query('partnerServiceProduktEnum', params.partnerServiceProduktEnum, {});
      rb.query('fromPostnummer', params.fromPostnummer, {});
      rb.query('toPostnummer', params.toPostnummer, {});
      rb.query('validTo', params.validTo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * delete partner from range of postnumre and service.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deletePostnummerServicePartner$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePostnummerServicePartner(params: {
    partnerNo?: number;
    partnerServiceProduktEnum?: OkEgisServiceModelsEntitiesEnumsPartnerServiceProduktEnum;
    fromPostnummer?: number;
    toPostnummer?: number;
    validTo?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<void> {

    return this.deletePostnummerServicePartner$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
